import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { AppSettings } from '../../../shared/app.settings';
import { StorageService } from './../../services/storage.service';
import { LoaderService } from './../../components/loader/loader.service';
import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { Message } from 'primeng/api';
import { HttpHeaders } from '@angular/common/http';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file.uploader.component.html'
})
export class FileUploaderComponent implements OnInit {

  @Input() accept;
  @Input() uploadButtonLabel;
  @Output() onFileUpload: EventEmitter<any> = new EventEmitter();
  @Output() onFileUploadEvent: EventEmitter<any> = new EventEmitter();
  maxSize = AppSettings.FILE_UPLOAD_MAX_SIZE_IN_BYTE;
  fileUploadUrl: string = AppSettings.UPLOAD_FILE_URL;
  maxSizeMessage;
  message: Message[] = [];
  appheaders: any;
  uploadedFiles: any[] = [];
  eventIdParam;

  constructor(
    private storageService: StorageService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private uiService: UiService,
    private commonService: CommonBindingDataService) {
    this.appheaders = new HttpHeaders().set("Authorization", 'Bearer ' + this.storageService.getItemFromSessionStorage(AppSettings.TOKEN_KEY));

  }

  ngOnInit() {
    this.commonService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.fileUploadUrl += '?eventId=' + this.eventIdParam;
    });

    if (!this.eventIdParam) {
      let tempEventId = this.commonService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
        this.fileUploadUrl += '?eventId=' + this.eventIdParam;

      }
    }
    this.maxSizeMessage = this.commonService.getLabel('file_size_limit');

  }
  onFileSelect(event) {
    const file = event.files[0];
    if (file.size > this.maxSize) {
      this.message = [];
      this.uiService.showMessage(this.commonService.getLabel("file_upload_error"), AppSettings.MESSAGE_TYPE.ERROR);
      return;
    }
  }

  onUpload(event) {
    // this.loaderService.show('page-center');
    this.onFileUploadEvent.emit(event);
    const response = event.originalEvent.body;
    this.onFileUpload.emit(response);
    this.loaderService.hide();
  }

  onBeforeUpload(event) {
    // const xhr = event.xhr;
    // xhr.setRequestHeader(AppSettings.HEADER_AUTHORIZATION,'Bearer ' + this.storageService.getItemFromSessionStorage(AppSettings.TOKEN_KEY));
    this.loaderService.show('page-center');
  }

  onUploadError(event: any) {
    this.message = [];
    // this.message.push({ severity: 'error', summary: 'Error', detail: this.commonService.getLabel('file_upload_error') });
    this.uiService.showMessage(this.commonService.getLabel("file_upload_error"), AppSettings.MESSAGE_TYPE.ERROR);
    this.loaderService.hide();
  }
}